import axios from 'axios';
import sha1 from 'sha1';
import qs from 'qs';
import router from '@/router';
import {
  Base64
} from 'js-base64';
import {
  Message
} from 'element-ui';
// 登录请求方法
const get_request = (url) => {
  return axios({
    method: "GET",
    url: url,
    // headers: {
    //   'Content-Type': 'application/x-www-form-urlencoded',
    // },
    traditional: true,

  })
};
const get_request_export = (url, params) => {
  params = transformRequest(params)
  return axios({
    method: "POST",
    url: url,
    // headers: {
    //   'Content-Type': 'application/jsons',
    // },
    data: params,
    responseType: 'blob'
  })
};
const get_request_login = (url, params) => {
  return axios({
    method: "POST",
    url: url,
    // headers: {
    //   'Content-Type': 'application/jsons',
    // },
    data: qs.stringify(params),
    traditional: true,
  })
};
const post_request_file = (url, params) => {
  let token = localStorage.getItem("yypt_web_token") || '';
  let fd = new FormData(); //参数的格式是formData格式的
  fd.append("file", params.file); //参数
  fd.append("filename", params.filename); //参数
  fd.append("note", params.note); //参数
  fd.append("row[token]", token); //参数
  return axios({
    method: "POST",
    url: url,
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    data: fd,
    traditional: true,
  })
};

const transformRequest = (params) => {
  let token = localStorage.getItem("yypt_web_token") || '';
  let sk = localStorage.getItem("yypt_web_sk") || '';
  let row = params['row'];
  row['token'] = token;
  row['time_stamp'] = '' + Date.parse(new Date()) / 1000;
  const newkey = Object.keys(row).sort();
  const newObj = {};
  for (let i = 0; i < newkey.length; i++) {
    newObj[newkey[i]] = row[newkey[i]];
  }
  let sign_list = [];
  for (let item in newObj) {
    let _key = item + '';
    let _val = newObj[item] + '';
    sign_list.push(Base64.encode(_key) + "=" + Base64.encode(_val));
  }
  // 5. 将将键值对重新组
  let sign_str = sign_list.join('&');
  sign_str = sk + sign_str + sk;
  sign_str = sha1(sign_str);
  params['sign'] = sign_str;
  params = qs.stringify(params)
  return params
}
// 通用公用方法
const post_request = (url, params) => {
  params = transformRequest(params)
  return axios({
    method: "POST",
    url: url,
    // headers: {
    //   'Content-Type': 'application/json'
    // },
    // x-www-form-data
    data: params,
    traditional: true,
    // timeout:5000

  })
};
let isReFreshPadding = true;
axios.interceptors.response.use(response => {
  const res = response.data
  if (res.code === undefined) {
    return res
  }
  if (res.code !== 0) {
    if (isReFreshPadding) {
      if (response.data.code === -9998) {
        isReFreshPadding = false
        router.push({
          path: "/login"
        })
        Message.error(res.message)
      }
    }
    if (response.data.code === -9997) {
      Message.error(res.message)
    }
    if (res.code === -1) {
      isReFreshPadding = true
      if (res.message == '密码错误' || res.message == '验证码错误' || res.message == '账号不存在') {
        Message.error(res.message)
        return res
      }
      Message.error(res.message)
    }
  } else {
    isReFreshPadding = true
    return res
  }
})
export {
  get_request,
  post_request,
  post_request_file,
  get_request_export,
  get_request_login
}



// WEBPACK FOOTER //
// ./src/api/axiosFun.js